import(/* webpackMode: "eager", webpackExports: ["MarketsHubPage"] */ "/vercel/path0/packages/app/src/containers/MarketsHub.tsx");
